import { useState } from "react";
import { BG, CARD, CARD2, CARD3, BD, TX, TX2, BL, GR, RD } from "../../utils/constants";
import axios from "../../utils/api";

const COUNTRIES = [
  "United States", "United Kingdom", "Canada", "Australia", "Israel", "Germany", "France", "Spain", "Italy",
  "Netherlands", "Belgium", "Switzerland", "Austria", "Sweden", "Norway", "Denmark", "Finland", "Ireland",
  "Portugal", "Poland", "Czech Republic", "Greece", "Turkey", "Ukraine", "Russia", "India", "China", "Japan",
  "South Korea", "Singapore", "Hong Kong", "United Arab Emirates", "Saudi Arabia", "South Africa", "Nigeria",
  "Egypt", "Brazil", "Mexico", "Argentina", "Chile", "Colombia", "New Zealand", "Other",
];

export default function CompleteProfileGate({ onComplete, onLogout }) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [country, setCountry] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    if (!phoneNumber.trim() || !country) { setError("Please fill in both fields."); return; }
    setLoading(true); setError("");
    try {
      const res = await axios.post("/api/auth/profile", { phoneNumber: phoneNumber.trim(), country });
      onComplete(res.data.user);
    } catch (e) {
      setError(e?.response?.data?.error || "Could not save your profile.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ts-scan-shell" style={{ minHeight: "100vh", background: BG, color: TX, fontFamily: "'IBM Plex Mono',monospace", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;600;700&family=Space+Grotesk:wght@800&display=swap');`}</style>
      <div className="ts-panel" style={{ background: CARD, border: `1px solid ${BD}`, borderRadius: 14, padding: 28, maxWidth: 420, width: "100%", boxShadow: "0 28px 80px rgba(0,0,0,0.45)" }}>
        <div className="ts-gradient-text" style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 900, fontSize: 22, marginBottom: 8 }}>
          Complete your profile
        </div>
        <div style={{ color: TX2, fontSize: 11, lineHeight: 1.8, marginBottom: 20 }}>
          Just a couple more details before you get started.
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={{ display: "block", fontSize: 8, color: TX2, letterSpacing: 2, marginBottom: 5 }}>PHONE NUMBER</label>
          <input
            type="tel"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="+1 555 123 4567"
            onKeyDown={(e) => e.key === "Enter" && submit()}
            style={{ width: "100%", background: CARD3, border: `1px solid ${BD}`, borderRadius: 8, padding: "10px 14px", color: TX, fontSize: 11, boxSizing: "border-box", fontFamily: "'IBM Plex Mono', monospace", outline: "none" }}
          />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ display: "block", fontSize: 8, color: TX2, letterSpacing: 2, marginBottom: 5 }}>COUNTRY</label>
          <select
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            style={{ width: "100%", background: CARD3, border: `1px solid ${BD}`, borderRadius: 8, padding: "10px 14px", color: TX, fontSize: 11, fontFamily: "'IBM Plex Mono', monospace", outline: "none" }}
          >
            <option value="">Select a country</option>
            {COUNTRIES.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>

        {error && (
          <div style={{ background: `${RD}12`, border: `1px solid ${RD}40`, borderRadius: 8, padding: "9px 13px", fontSize: 10, color: RD, marginBottom: 16, lineHeight: 1.5 }}>
            {error}
          </div>
        )}

        <button
          onClick={submit}
          disabled={loading}
          style={{ width: "100%", background: loading ? CARD2 : `linear-gradient(135deg,${GR},${BL})`, border: "none", borderRadius: 10, padding: "13px 0", color: loading ? TX2 : "#000", fontSize: 11, fontWeight: 800, cursor: loading ? "not-allowed" : "pointer", letterSpacing: 2, marginBottom: 12 }}
        >
          {loading ? "SAVING..." : "CONTINUE →"}
        </button>
        <button className="btn" onClick={onLogout} style={{ width: "100%", background: "transparent", border: `1px solid ${BD}`, borderRadius: 9, padding: 10, color: TX2, fontSize: 9 }}>Sign out</button>
      </div>
    </div>
  );
}
